import axiosInstance from "../instance/axiosInstance";

class ContactApi {
  static async contactSalesTeam(formData) {
    try {
      const response = await axiosInstance.post(
        "/contact/sales-team",
        formData
      );
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
}

export default ContactApi;
